import { SolType } from '@sol/components';
import { ScopeModule } from '../services/scope-v3.service';

export class AsmScopesType {
  public static readonly scopeModule = SolType.ofPrimitive<ScopeModule>(
    'asm.scopeModule',
    () =>
      ({
        id: '',
        displayName: '',
        externalIdentifier: '',
        enabled: false,
        licensed: false,
        created: new Date(),
      }) as ScopeModule,
  );
  public static readonly subscopeName = SolType.ofPrimitive<string>(
    'subscopeName',
    () => '',
    v => v ?? '',
    s => s,
    SolType.string,
  );
}
